export default "__VITE_ASSET__CM$YO45U__"